import type { RouteObject } from "react-router";

import { ErrorPage } from "@/components/Error/ErrorPage";
import { canAccessHome } from "@/components/ProjectSidebar/permissions";
import { RequireAuth } from "@/components/Routing/RequireAuth";
import { RequireFeatureFlag } from "@/components/Routing/RequireFeatureFlag";
import { dashboardStartupContext, shouldRevalidateOnPathChange } from "@/providers/dashboardStartup";
import { routes } from "@/routes";

import { projectHomeRoutes } from "./routes";

export const projectHomeRoute = [
  {
    path: projectHomeRoutes.home,
    // Start the V3 home's widget queries alongside the session user.
    loader: ({ context, params, request }) => {
      const startup = context.get(dashboardStartupContext);
      if (startup) {
        import("./pages/home/projectHomeQueries")
          .then(({ prefetchProjectHomeRoute }) => prefetchProjectHomeRoute(startup, params.slug, request.url))
          .catch(() => {});
      }

      return null;
    },
    shouldRevalidate: shouldRevalidateOnPathChange,
    lazy: async () => {
      const [{ LegacyProjectHomePage }, { ProjectHomePage }] = await Promise.all([
        import("./pages/home-legacy/LegacyProjectHomePage"),
        import("./pages/home/ProjectHomePage"),
      ]);

      return {
        element: (
          <RequireAuth permission={canAccessHome} redirect={(slug) => routes.communityFeed.list({ slug })}>
            <RequireFeatureFlag flag="isDashboardV3Available" fallback={<LegacyProjectHomePage />}>
              <ProjectHomePage />
            </RequireFeatureFlag>
          </RequireAuth>
        ),
      };
    },
  },
  { path: "*", element: <ErrorPage status={404} /> },
] satisfies RouteObject[];
